import { render } from "./MadeItem.vue?vue&type=template&id=62523cfc&scoped=true"
import script from "./MadeItem.vue?vue&type=script&lang=js"
export * from "./MadeItem.vue?vue&type=script&lang=js"

import "./MadeItem.vue?vue&type=style&index=0&id=62523cfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62523cfc"]])

export default __exports__